import moment from "moment";
import {
    FETCH_COLLECTIONS_LIST,
    FETCH_COLLECTIONS_POSTS,
    CHANGE_TEAM_OR_OWN,
    CHANGE_COLLECTION_TYPE,
    CHANGE_COLLECTION_SORT_TYPE,
    CHANGE_COLLECTION_FILTER,
    FETCH_ALERTS_LIST,
    ADD_TO_COLLECTION,
    BULK_ADD_TO_COLLECTION,
    TOGGLE_COLLECTION_FILTERS,
    UPDATE_SELECTED_FILTER_COLLECTIONS,
    // DELETE_FROM_COLLECTION,
    BULK_DELETE_FROM_COLLECTION,
    UPDATE_ASSIGNED_STATUS,
    BULK_UPDATE_ASSIGNED_STATUS,
    SET_COVER_PHOTO,
    UPDATE_CURRENT_COLLECTION,
    REMOVE_CURRENT_COLLECTION,
    APPLY_FILTER_COLLECTION,
    RESET_CURRENT_COLLECTION_FILTER,
    UPDATE_FILTER_REFINE_SORT_COLLECTION,
    UPDATE_CUSTOM_QUERY_COLLECTION,
    DASHBOARD_UPDATE_ASSIGNED_STATUS_COLLECTION,
} from "../actions/collectionsActions";
import { toast } from "react-toastify";

import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initialState = {
    teamOrOwn: "team",
    collection_type: "all",
    collectionsList: [],
    collectionsListFetching: false,
    collectionsListFetched: false,
    totalCollections: 0,
    collectionPosts: [],
    collectionPostsFetching: false,
    collectionPostsFetched: false,
    totalCollectionPosts: 0,
    noCollectionPostsFetched: 0,
    allalertsList: [],
    freeAlertsList: [],
    syncedAlertsList: [],
    alertListFetching: false,
    collectionOffset: 1,
    collectionShowFilter: false,

    currentCollection: null,

    // filters
    filterRefineSort: "published_date_desc",
    filters: {
        countries: ["selectAll"],
        platforms: ["selectAll"],
        languages: ["selectAll"],
        duration: "custom",
        endDateTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        startDateTime: moment(new Date().setFullYear(new Date().getFullYear() - 1)).format("YYYY-MM-DD HH:mm:ss"),
        publications: [],
        entityType: "all",
        entitySubType: "all",
        filterKeyword: "",
        rollingDate: true,
        topics: [],
        subtopics: [],
    },
    filterRefineFilter: {
        sentiment: ["all"],
        sentimentType: "all",
        contentSafety: "sfw",
        contentSafetyType: "all",
        media: "all",
        postType: "all",
        sampling: "100",
        channel: "all",
        exclusion: "yes",
        reviewStatus: "opened",
    },
    customQuery: "",
    filterUpdated: 0,
    filterRefineUpdate: 0,
    otherFiltersUpdated: 0,
};

const collectionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case isPending(FETCH_COLLECTIONS_LIST):
            return {
                ...state,
                collectionsListFetching: true,
                collectionsList: [],
            };
        case isRejected(FETCH_COLLECTIONS_LIST):
            return {
                ...state,
                collectionsListFetching: false,
            };
        case isFulfilled(FETCH_COLLECTIONS_LIST):
            localStorage.setItem("collectionList", JSON.stringify(action.payload.data));
            return {
                ...state,
                collectionsList: action.payload.data,
                totalCollections: action.payload.data.length,
                collectionsListFetching: false,
                collectionsListFetched: true,
            };
        case isPending(FETCH_COLLECTIONS_POSTS):
            return {
                ...state,
                collectionPostsFetching: true,
                collectionPosts: [],
            };
        case isRejected(FETCH_COLLECTIONS_POSTS):
            return {
                ...state,
                collectionPostsFetching: false,
            };
        case isFulfilled(FETCH_COLLECTIONS_POSTS):
            return {
                ...state,
                collectionPosts: action.payload.hits.hits,
                totalCollectionPosts: action.payload.hits.total,
                collectionPostsFetching: false,
                collectionPostsFetched: true,
                noCollectionPostsFetched: action.payload.hits.hits.length,
                collectionOffset: action.payload.offset,
            };
        case CHANGE_TEAM_OR_OWN:
            return {
                ...state,
                teamOrOwn: action.payload,
            };
        case CHANGE_COLLECTION_TYPE:
            return {
                ...state,
                collection_type: action.payload,
            };
        case CHANGE_COLLECTION_SORT_TYPE:
            return {
                ...state,
                collectionPostsSortBy: action.payload,
            };
        case CHANGE_COLLECTION_FILTER:
            return {
                ...state,
                collectionPostsFilterBy: action.payload,
            };
        case isRejected(FETCH_ALERTS_LIST):
            return {
                ...state,
                alertListFetching: false,
            };
        case isPending(FETCH_ALERTS_LIST):
            return {
                ...state,
                alertListFetching: true,
            };
        case isFulfilled(FETCH_ALERTS_LIST):
            {
                let free_alerts = [];
                let synced_alerts = [];
                action.payload.data.map((a) => {
                    if (!a.synced_collections.length) free_alerts.push(a);
                    else synced_alerts.push(a);
                });
                return {
                    ...state,
                    allAlertsList: action.payload.data,
                    freeAlertsList: free_alerts,
                    syncedAlertsList: synced_alerts,
                    alertListFetching: false,
                };
            }
            // case isFulfilled(ADD_TO_COLLECTION):
            //     if (action.payload) toast.success("Successfully Added Post To Collection");
            //     break;
            // case isFulfilled(BULK_ADD_TO_COLLECTION):
            //     toast.success("All the selected posts have been added successfully to the collection");
            //     return state;
            // case isFulfilled(DELETE_FROM_COLLECTION):
            //     toast.success("Deleted the post from Collection");
            return state;
        case isFulfilled(BULK_DELETE_FROM_COLLECTION):
            toast.success("Deleted bulk posts from Collection");
            return state;
        case TOGGLE_COLLECTION_FILTERS:
            return { ...state, collectionShowFilter: !state.collectionShowFilter };
        case UPDATE_SELECTED_FILTER_COLLECTIONS:
            return {
                ...state,
                collectionFilters: action.payload,
            };
            // case isFulfilled(UPDATE_ASSIGNED_STATUS):
            //     toast.success("Updated assigned status");
            return { ...state };
        case isFulfilled(BULK_UPDATE_ASSIGNED_STATUS):
            toast.success("Review status for all the selected posts updated");
            return { ...state };
        case isFulfilled(SET_COVER_PHOTO):
            toast.success("Cover photo for the collection set successfully");
            return { ...state };
        case UPDATE_CURRENT_COLLECTION:
            return {
                ...state,
                currentCollection: action.payload,
            };
        case REMOVE_CURRENT_COLLECTION:
            return {
                ...state,
                currentCollection: null,
            };

        case APPLY_FILTER_COLLECTION: {
            return {
                ...state,
                filters: action.payload.filters,
                filterRefineFilter: action.payload.filterRefineFilter,
                filterUpdated: state.filterUpdated + 1,
            };
        }
        case RESET_CURRENT_COLLECTION_FILTER: {
            let filters = {
                filterRefineFilter: initialState.filterRefineFilter,
                filters: initialState.filters,
                filterRefineSort: initialState.filterRefineSort,
                filterRefineUpdate: 0,
                filterUpdated: 0,
            };
            return {
                ...state,
                ...filters,
            };
        }
        case UPDATE_FILTER_REFINE_SORT_COLLECTION:
            return { ...state, filterRefineSort: action.payload, filterRefineUpdate: state.filterRefineUpdate + 1 };
        case UPDATE_CUSTOM_QUERY_COLLECTION: {
            const { value, applyFilter } = action.payload;
            if (applyFilter) return { ...state, customQuery: value, otherFiltersUpdated: state.otherFiltersUpdated + 1 };
            else return { ...state, customQuery: value };
        }
        case isFulfilled(DASHBOARD_UPDATE_ASSIGNED_STATUS_COLLECTION): {
            return {
                ...state,
                filterRefineUpdate: state.filterRefineUpdate + 1,
            };
        }
        default:
            return state;
    }
};

export default collectionsReducer;
